var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 d-flex p-2 position-absolute"},[_c('AutoSaveConfiguration')],1)}
var staticRenderFns = []

export { render, staticRenderFns }